export default __webpack_public_path__ + "static/media/results-background.481c1683.png";